export const WORLD_MAP_CONFIG = {
  center: [40, 0] as [number, number],
  zoom: 1.4,
  minZoom: 1.4,
  maxZoom: 5,
};
